import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import api from "@/api/api.js";
import ArchiveHint from "./ArchiveHint.jsx";

const FielDownload = ({ companyId, statusOnly = false }) => {
  const [sig, setSig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    let active = true;
    setLoading(true);
    api
      .get(`/companies/${companyId}/digitalSignature/latest`)
      .then(({ data }) => active && setSig(data))
      .catch(() => active && setSig(null))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [companyId]);

  const handleDownload = async () => {
    if (busy || !sig?.id) return;
    setBusy(true);
    try {
      const res = await api.get(
        `/companies/${companyId}/digitalSignature/${sig.id}/download`,
        { responseType: "blob" },
      );
      const cd = res.headers?.["content-disposition"] || "";
      const match = /filename="?([^"]+)"?/.exec(cd);
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = match?.[1] || sig.fileIdentifier || "fiel.7z";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      /* noop */
    } finally {
      setBusy(false);
    }
  };

  if (loading) return <Spinner animation="border" size="sm" />;

  if (statusOnly)
    return (
      <span className={`badge bg-${sig ? "success" : "secondary"}`}>
        FIEL: {sig ? "Sí" : "No"}
      </span>
    );

  if (!sig)
    return (
      <span className="text-muted">Sin FIEL (.cer/.key) registrada.</span>
    );

  return (
    <span className="d-inline-flex align-items-center">
      <Button
        size="sm"
        variant="outline-success"
        onClick={handleDownload}
        disabled={busy}
      >
        <i className="bi bi-download me-1" />
        Descargar FIEL (.cer/.key + contraseña)
      </Button>
      <ArchiveHint />
    </span>
  );
};

export default FielDownload;
